import {
	makeStyles,
	shorthands,
	tokens,
	typographyStyles,
} from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		width: "100%",
		height: "100%",
		...shorthands.overflow("hidden"),
	},
	searchInput: {
		...shorthands.margin(tokens.spacingHorizontalS),
		...shorthands.border("none"),
	},
	headerTitle: {
		...typographyStyles.body1Stronger,
	},
	listItemHeader: {
		fontWeight: tokens.fontWeightSemibold,
	},
	accordion: {
		flexGrow: 1,
		...shorthands.overflow("auto"),
	},
	accordionItem: {
		paddingLeft: "30px",
	},
	accordionHeader: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase200,
		fontStyle: "normal",
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase200,
		textAlign: "center",
		color: tokens.colorNeutralForeground3,
		"& span:last-child": {
			...shorthands.margin("", "", "", tokens.spacingHorizontalS),
		},
	},
	accordionPanel: {
		...shorthands.margin(0),

		"> ul": {
			...shorthands.margin(0),
		},
	},
	noResultText: {
		...shorthands.margin("1rem", "auto"),
	},
});
